/* 🤖 this file was generated by svg-to-ts */
export const siriusQualityInspectionPictogram: {
  name: 'quality_inspection_pictogram';
  data: string;
} = {
  name: 'quality_inspection_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="m42.673 41.094-8.286-8.286a16.766 16.766 0 1 0-1.58 1.579l8.287 8.286a1.117 1.117 0 0 0 1.579-1.579Zm-35.4-19.306A14.514 14.514 0 1 1 21.789 36.3 14.53 14.53 0 0 1 7.274 21.787Z" fill="currentColor"/></svg>`
};
